import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useFormTheme } from '../../../contexts/FormThemeContext'; // Adjust the import path as necessary

const FullPageView = () => {
  const { colors } = useFormTheme(); // Access the colors from the theme context

  // Simulate a few sections to illustrate the layout
  const sections = [
    { id: 1, title: "Section 1", description: "This is the first section of your form." },
    { id: 2, title: "Section 2", description: "This is the second section of your form." },
    { id: 3, title: "Section 3", description: "This is the third section of your form." },
  ];

  return (
    <Box sx={{
      padding: 3,
      width: '100%',
      overflowY: 'auto',
      backgroundColor: colors.backgroundColor // Set background color here
    }}>
      {sections.map((section) => (
        <Paper 
          key={section.id} 
          elevation={3} 
          sx={{ 
            marginBottom: 2, 
            padding: 2, 
            backgroundColor: '#fafafa'  // Keep Paper background subtle and consistent
          }}
        >
          <Typography variant="h5" component="h3" sx={{ marginBottom: 1 }}>
            {section.title}
          </Typography>
          <Typography variant="body1">
            {section.description}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default FullPageView;
